const singleAddressLineCountries = ['US', 'CA'];

/* eslint-disable import/prefer-default-export */
export const showSingleAddressLine = (countryCode) =>
  singleAddressLineCountries.indexOf(countryCode) !== -1;
